import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { OPEN_TOFU_MIGRATE } from "./gql";

const useOpenTofuMigrate = createDefaultMutationHook(OPEN_TOFU_MIGRATE);

export default useOpenTofuMigrate;
